export default __webpack_public_path__ + "static/media/Gamble.33c906cb.png";